import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import PresortDemo from "../components/table/DataTable";
import { useAcceptOrderMutation, useGetManifestDataQuery, useGetOrderByPartialQuery } from "../store/api/orderAPI";
import { orderPartialColumn } from "../metadata/order";
import { useLocation } from "react-router-dom";
import { useAcceptPartialMutation, useDeliveryTonomexMutation } from "../store/api/partialApi";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import ExcelExport from "../components/common/ExcelExport";
import { t } from "i18next";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const AcceptBatch = () => {
	const [orderCode, setOrderCode] = useState("");
	const [highlightedOrder, setHighlightedOrder] = useState(null);
	const [deliverToNomexDialog, setDeliverToNomexDialog] = useState();
	const orderPartialColumnTr = useTranslatedColumns(orderPartialColumn);
	const [acceptOrder] = useAcceptOrderMutation()
	const location = useLocation();
	const partial_code = location.state?.partial_code;
	const [acceptPartial] = useAcceptPartialMutation()
	const [nomexDeliveryOrder] = useDeliveryTonomexMutation()
	const { data: menifestData } = useGetManifestDataQuery({ partial: undefined, partial_code: partial_code }, {
		skip: !partial_code
	})
	const { data } = useGetOrderByPartialQuery(partial_code, {
		skip: !partial_code
	});
	const toast = useRef(null);
	const [items, setItems] = useState([]);



	const handleOrderScan = (orderCode) => {
		setHighlightedOrder(orderCode);
		// 🔊 Воспроизведение звука
		const newState = items.map(el => {
			if (el.tracking_number == orderCode) {
				const newObj = { ...el, status: 22 };
				acceptOrder({ guid: el.guid });
				toast.current.show({
					severity: "info",
					summary: t("orderScanned"),
					detail: `Код: ${orderCode}`,
				});
				const audio = new Audio("/scun.mp3"); // если файл в public/sounds/
				audio.play();
				return newObj;
			}
			return el;
		});
		setItems(newState);

	};

	const handleNomexDeliveryOrder = () => {
		nomexDeliveryOrder({ partial: partial_code });
		setDeliverToNomexDialog(false);
	};

	const totals = () => {
		let quantity = 0;
		let weight = 0;
		for (let item of items) {
			quantity += 1;
			weight += item.weight || 0;
		}
		return { quantity, weight };
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer={t("count")} colSpan={0} footerStyle={{ textAlign: "right" }} />
				<Column footer={totals().quantity} />
				{/* <Column footer={totals().weight} /> */}
			</Row>
		</ColumnGroup>
	);

	const rowClassName = (rowData) => {
		return rowData.code === highlightedOrder ? 'highlighted-row' : '';
	};
	useEffect(() => {
		setItems(data ?? [])
	}, [data])

	//Код тнв в манифест добавить категорию 
	return (
		<>
			<Toast ref={toast} />
			<div style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center"
			}}>
				<p
					style={{
						paddingLeft: 12,
						fontSize: 18,
						fontWeight: 600,
					}}
				>
					{t("acceptPartial")}: {location.state.partial_code}
				</p>
				<div >
					<ExcelExport data={menifestData} /> <span> </span>
					{!!(location.state.status == 16) && <MyButton label={t("regisArrival")} icon="pi pi-check" outlined onClick={async () => {
						try {
							await acceptPartial({
								partial: location.state.guid
							})
							toast.current.show({
								severity: "info",
								summary: t("partialRecivedWare"),
								detail: `${orderCode}`,
							});
						} catch (e) {
							toast.current.show({
								severity: "error",
								summary: t("partialNoRecivedWare"),
								detail: `${orderCode}`,
							});
						}
					}} />}
				</div>
			</div>

			<Dialog
				header="Передать в Nomex"
				visible={deliverToNomexDialog}
				style={{ width: '30rem' }}
				onHide={() => setDeliverToNomexDialog(false)}
				footer={
					<div className="p-d-flex p-jc-end">
						<Button label="Отмена" className="p-button-text" onClick={() => setDeliverToNomexDialog(false)} />
						<Button label="Отправить" icon="pi pi-check" onClick={handleNomexDeliveryOrder} autoFocus />
					</div>
				}
			>

			</Dialog>
			<div style={{ display: "flex", gap: 12, paddingLeft: 12 }}>
				{location.state.status == 18 ?
					<Editor
						attr="orderCode"
						trim
						onBlur={(e, attr, value) => {
							handleOrderScan(value)
						}}
						placeholder={t("scanOrder")}
					/> : ""
				}
			</div>

			<PresortDemo
				data={items}
				isLoading={false}
				column={orderPartialColumnTr}
				toggleSidebar={() => { }}
				footerColumnGroup={footerGroup}
				rowClassName={rowClassName}
			/>

			<style jsx>{`
				.highlighted-row {
					background-color: #d4edda !important;
				}
			`}</style>
		</>
	);
};

export default AcceptBatch;
